import getFileExtension  from "./file_extension";

const VALID_FORMATS = ['docx', 'pptx', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'tiff', 'mp4', 'mov', 'webm', 'ogg', 'wav', 'mp3'];

export default (filename) => VALID_FORMATS.includes(getFileExtension(filename));
